import { render } from "./BestServices.vue?vue&type=template&id=1328c08f"
import script from "./BestServices.vue?vue&type=script&lang=js"
export * from "./BestServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__